import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";

import { Header as EworkitHeader, IHeaderProps as IEworkitHeaderProps, TStyleTextColor } from "@/eworkitComponents";
import { buildTextColorVariantClassNames, TColorVariant } from "@/style/colorVariants";

import "./_header.scss";

export interface IHeaderProps extends Omit<IEworkitHeaderProps, "color"> {
  color?: TColorVariant;
  decorLine?: boolean;
  blur?: boolean;
}

export const Header: FunctionComponent<IHeaderProps> = memo(props => {
  const colorVariant = props.color || "inherit";
  const eworkitColor = colorVariant as TStyleTextColor;

  return (
    <EworkitHeader
      {...props}
      className={classNames(props.className, buildTextColorVariantClassNames(colorVariant), {
        "el-header--decor-line": props.decorLine || false,
        "el-header--blur": props.blur,
      })}
      color={eworkitColor}
    />
  );
});
